import { CancelButton } from "@/components/admin/cancel-button"
import { SaveButton } from "@/components/admin/form"
import { cn } from "@/lib/utils"
import type { FormProps } from "ra-core"
import { Form } from "ra-core"
import type { ReactNode } from "react"
import * as React from "react"
import { Children } from "react"

export const SimpleForm = ({
  children,
  className,
  toolbar = defaultFormToolbar,
  ...rest
}: SimpleFormProps) => (
  <Form className={cn(`flex flex-col gap-4 w-full`, className)} {...rest}>
    {children}
    {toolbar}
  </Form>
)

export const FormToolbar = ({
  children,
  className,
  ...rest
}: FormToolbarProps) => (
  <div
    {...rest}
    className={cn(
      "sticky pt-4 pb-4 md:block md:pt-2 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-background to-10%",
      className
    )}
    role="toolbar"
  >
    {Children.count(children) === 0 ? (
      <div className="flex flex-row gap-2 justify-end">
        <CancelButton />
        <SaveButton alwaysEnable />
      </div>
    ) : (
      children
    )}
  </div>
)

export type SimpleFormProps = {
  children: ReactNode
  className?: string
  toolbar?: ReactNode
} & FormProps

export interface FormToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
  className?: string
}

const defaultFormToolbar = <FormToolbar />
